module.exports = __webpack_public_path__ + "images/assets/e96dc948736bd10af78b83cc6834dc97.svg";